var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V341.961H0V-0.00585938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 341.961H513V-0.00585938L0 341.961Z",
    fill: "#012A87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.889 -0.00585938H0V167.22L250.889 -0.00585938Z",
    fill: "#F9D90F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.674 118.525L152.898 139.767H177.446L165.122 160.908L177.446 182.149H152.898L140.674 203.391L128.45 182.149H103.903L116.227 160.908L103.903 139.767H128.45L140.674 118.525Z",
    fill: "#DC171D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.674 107.595C111.23 107.595 87.3615 131.464 87.3615 160.908C87.3615 190.352 111.23 214.22 140.674 214.22C170.118 214.22 193.987 190.352 193.987 160.908C193.987 131.464 170.118 107.595 140.674 107.595ZM78.3615 160.908C78.3615 126.493 106.26 98.5951 140.674 98.5951C175.089 98.5951 202.987 126.493 202.987 160.908C202.987 195.322 175.089 223.22 140.674 223.22C106.26 223.22 78.3615 195.322 78.3615 160.908Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1506"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 341.967,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBq);
export default __webpack_public_path__ + "static/media/BQ.1c44751f6fb99652bd8ca3efe2f7bc13.svg";
export { ForwardRef as ReactComponent };